(() => {
  if (window.OlouiooService) return;
  const configs = new WeakMap();
  const format = (text, values) => String(text || '').replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
  function read(owner) {
    if (!owner) return null;
    const script = owner.querySelector('[data-service-booking-config]');
    if (!script) return null;
    if (!configs.has(script)) configs.set(script, JSON.parse(script.textContent));
    const data = configs.get(script), scope = owner.closest('.product-information');
    const quantity = Math.max(1, Number(owner.querySelector('[name="quantity"]')?.value) || 1);
    const id = Number(owner.querySelector('[name="id"]')?.value) || Number(data.selectedVariant?.id);
    const index = data.variantIds.indexOf(id);
    const price = Number(index >= 0 ? data.variantPrices[index] : (Number(data.selectedVariant?.id) === id ? data.selectedVariant.price : 0)) || 0;
    const picked = [...(scope?.querySelectorAll('variant-picker input:checked,variant-picker select,signature-menu-picker input:checked') || [])];
    const choices = picked.map(input => ({ label: input.closest('fieldset,.variant-option')?.querySelector('legend,.variant-option__label-text')?.textContent || input.name, value: input.value, basis: input.closest('[data-count-basis]')?.dataset.countBasis }));
    const countChoice = choices.find(choice => /guest|serving|number of drinks/i.test(choice.label));
    const perUnit = data.handle === 'la-table' ? 8 : Number(countChoice?.value.match(/\d+/)?.[0]) || null;
    const basis = data.handle === 'la-coupe-welcome-toast-table' || countChoice?.basis === 'drinks' ? 'drinks' : 'guests';
    const count = perUnit ? perUnit * quantity : null;
    const unit = quantity === 1 ? data.one : data.many;
    const units = quantity + ' ' + unit;
    const capacity = count ? (basis === 'guests' && data.handle !== 'la-table' ? data.upTo + ' ' : '') + count + ' ' + data[basis] : '';
    const drinksPerGuest = Number(data.drinksPerGuest) || 1;
    const drinkCount = count ? count * (basis === 'guests' ? drinksPerGuest : 1) : null;
    const allowance = drinksPerGuest > 1 && drinkCount ? format(data.hostedAllowance, {count:drinkCount}) : perUnit ? format(data.perUnit, {count:perUnit, basis:data[basis], unit:data.one}) : data.towerNote;
    const finish = choices.find(choice => /finish|drinkware/i.test(choice.label))?.value || '';
    const hours = Number(owner.querySelector('[data-hire-duration]')?.value) || 3;
    const duration = owner.querySelector('[data-hire-duration]')?.selectedOptions[0]?.textContent.trim() || '';
    return { id, productId:data.id, title:data.title, handle:data.handle, quantity, price, total:price * quantity + (window.OlouiooDuration?.cost(owner) || 0), units, one:data.one, shortTitle:data.title.split(' — ')[0], capacity, allowance, heading:data.heading, guests:basis === 'guests' ? count : null, count, drinkCount, drinksPerGuest, basis, finish:/acrylic/i.test(finish) ? 'Premium acrylic' : /glass/i.test(finish) ? 'Glass' : null, hours, duration, summary:[units, capacity, drinksPerGuest > 1 && drinkCount ? format(data.hostedTotal, {count:drinkCount}) : ''].filter(Boolean).join(' · ') };
  }
  function remember(event) {
    const variant = event.detail?.resource || event.detail?.variant;
    const productId = event.detail?.data?.productId || event.detail?.productId;
    if (!variant?.id || !productId || !Number.isFinite(Number(variant.price))) return;
    document.querySelectorAll('[data-service-booking-config]').forEach(script => {
      if (!configs.has(script)) configs.set(script, JSON.parse(script.textContent));
      const data = configs.get(script);
      if (String(data.id) !== String(productId)) return;
      const index = data.variantIds.indexOf(Number(variant.id));
      if (index < 0) { data.variantIds.push(Number(variant.id)); data.variantPrices.push(Number(variant.price)); }
      else data.variantPrices[index] = Number(variant.price);
      data.selectedVariant = { id:Number(variant.id), price:Number(variant.price) };
    });
  }
  document.addEventListener('variant:update', remember);
  document.addEventListener('olouioo:service-variant', remember);
  function paint(scope = document) {
    scope.querySelectorAll('.buy-buttons-block product-form-component').forEach(owner => {
      const state = read(owner), description = owner.querySelector('[data-service-quantity-description]');
      if (state && description) description.textContent = [state.allowance, state.quantity > 1 ? state.capacity : ''].filter(Boolean).join(' · ');
    });
    document.dispatchEvent(new CustomEvent('olouioo:service-state'));
  }
  window.OlouiooService = { read };
  let queued = false;
  const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; paint(); }); };
  ['change','input','quantity-selector:update','variant:update','olouioo:service-variant'].forEach(name => document.addEventListener(name, event => { if (event.target.closest?.('.product-information')) queue(); }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => paint());
  else paint();
})();


